<template>
  <section v-if="transporter.serviceOptions">
    <h6 class="q-mb-md">Service Options:</h6>

    <div class="bg-gray q-pr-md q-pb-md q-ml-none row q-col-gutter-md">
      <div class="col-12 col-md-6">
        <q-select
          v-model="transporterSync.serviceOptions.truckCount"
          emit-value
          map-options
          label="Number of Trucks"
          :options="truckCountOptions"
        />
      </div>

      <div class="col-12 col-md-6">
        <q-select
          v-model="transporterSync.serviceOptions.deliveryTypes"
          multiple
          no-error-icon
          emit-value
          map-options
          label="Delivery Types"
          error-message="At least 1 delivery type is required"
          :error="getErrorState(v.transporter.serviceOptions.deliveryTypes)"
          :options="deliveryTypeList"
        />
      </div>

      <div class="col-12 col-md-6">
        <q-select
          v-model="transporterSync.serviceOptions.truckTypes"
          multiple
          no-error-icon
          emit-value
          map-options
          label="Truck Types"
          error-message="At least 1 truck type is required"
          :error="getErrorState(v.transporter.serviceOptions.truckTypes)"
          :options="truckTypeList"
        />
      </div>

      <div class="col-12 col-md-6">
        <q-select
          v-model="transporterSync.serviceOptions.containerTypes"
          multiple
          emit-value
          map-options
          label="Container Types"
          error-message="At least 1 container type is required"
          :error="getErrorState(v.transporter.serviceOptions.containerTypes)"
          :options="containerTypeList"
        />
      </div>

      <div v-if="terminals.length" class="col-12 col-md-6">
        <q-select
          v-model="transporterSync.terminals"
          multiple
          map-options
          option-label="name"
          option-value="id"
          label="Terminal Access"
          :options="terminals"
        />
      </div>
    </div>
  </section>
</template>

<script>
import getErrorState from '@/utils/mixins/getErrorState';

export default {
  mixins: [getErrorState],
  props: {
    transporter: {
      type: Object,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      terminals: [],
      truckCountOptions: [
        { label: '1', value: 1 },
        { label: '2-5', value: 2 },
        { label: '6-10', value: 6 },
        { label: '11-20', value: 11 },
        { label: '21-50', value: 21 },
        { label: '51+', value: 50 },
      ],
      truckTypeList: [
        { value: 'side-loader', label: 'Side Loader' },
        { value: 'skel-trailer', label: 'Skel Trailer' },
        { value: 'tray-top', label: 'Tray Top' },
        { value: 'tipping-skel', label: 'Tipping Skel' },
      ],
      deliveryTypeList: [
        { value: 'side-lifter', label: 'Drop Out' },
        { value: 'wait-for-unpack', label: 'Wait For Unpack' },
        { value: 'drop-trailer', label: 'Drop Trailer' },
      ],
      containerTypeList: [
        { label: '20ft Dry', value: '20-dry' },
        { label: '40ft Dry', value: '40-dry' },
        { label: '40ft High Cube', value: '40-high-cube' },
        { label: '20ft Reefer', value: '20-reefer' },
        { label: '40ft Reefer', value: '40-reefer' },
        { label: '20ft Open Top', value: '20-open-top' },
        { label: '40ft Open Top', value: '40-open-top' },
        { label: '20ft Flat Rack', value: '20-flat-rack' },
        { label: '40ft Flat Rack', value: '40-flat-rack' },
        { label: '20ft ISO Tank', value: '20-iso-tank' },
      ],
    };
  },

  computed: {
    transporterSync: {
      get() {
        return this.transporter;
      },
      set(val) {
        this.$emit('update:transporter', val);
      },
    },
  },

  async created() {
    const { data } = await this.$axios.get(`/admin/transporter/${this.transporter.id}/terminals`, {
      params: { cityId: this.transporter.operationCityId },
    });

    this.terminals = data;
  },
};
</script>

<style></style>
